__webpack_require__.p = "https://v2-base.apps.qorcommerce.io/";